import styles from "./index.module.scss"
import { useEffect, useState } from "react"
import { LineChart, Line, XAxis, YAxis, CartesianGrid } from "recharts"

export const LineChartComponent = ({ actionFilter, chartAttentionPoints }) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useEffect(() => {
    const updateDimensions = () => {
      const width = document.getElementById("chart-container").offsetWidth - 30
      let height = width * 0.42

      if (width > 592) {
        height = width * 0.37
      }

      setDimensions({ width, height })
    }

    updateDimensions()

    window.addEventListener("resize", updateDimensions)
    return () => window.removeEventListener("resize", updateDimensions)
  }, [])


  const lengthMultipliers = [
    { max: 15, multiplier: 1 },
    { max: 20, multiplier: 1.4 },
    { max: 30, multiplier: 2 },
    { max: 45, multiplier: 2.8 },
    { max: 60, multiplier: 3.5 },
    { max: 75, multiplier: 4.3 },
    { max: 90, multiplier: 5 },
    { max: 100, multiplier: 7 },
    { max: 150, multiplier: 8.5 },
    { max: Infinity, multiplier: 11 },
  ]

  function getWidthMultiplier(length) {
    for (const entry of lengthMultipliers) {
      if (length <= entry.max) {
        return entry.multiplier
      }
    }
    return 1
  }

  const dt = chartAttentionPoints



const max = Math.max(...dt.map((item) => +item.rejection))


  return (
    <div id="chart-container" className={styles.chartContainer}>
      <LineChart
        width={dimensions.width * getWidthMultiplier(dt?.length)}
        height={dimensions.height}
        data={dt}
      >
        <CartesianGrid strokeDasharray="3 0" />
        <XAxis dataKey="run" />
        <YAxis  
        domain={[0, max]}
                  // tickMargin={10}
                  />
        <Line
          opacity={actionFilter.reject_quant ? 1 : 0}
          type="linear"
          dataKey="rejection"
          dot={false}
          strokeWidth={3}
          stroke="#ff3541"
        />
        <Line
          opacity={actionFilter.alert_quant ? 1 : 0}
          type="linear"
          dataKey="alert"
          dot={false}
          strokeWidth={3}
          stroke="#ffae00"
        />
        <Line
          opacity={actionFilter.reject_quali_semi_quant ? 1 : 0}
          type="linear"
          dataKey="non_compliance"
          dot={false}
          strokeWidth={3}
          stroke="#b83ee3"
        />
      </LineChart>
    </div>
  )
}
